import type { ReactNode } from 'react'
import css from './DropdownIcons.module.css'

interface DropdownIcon {
    icon: ReactNode
    onClick?: () => void
}

interface DropdownIconsProps {
    icons: DropdownIcon[]
}

const DropdownIcons = ({ icons }: DropdownIconsProps) => {
    return (
        <div className={css.dropdown_icons}>
            {icons.map((item, index) => (
                <div key={index} className={css.icon} onClick={item.onClick}>
                    {item.icon}
                </div>
            ))}
        </div>
    )
}

export default DropdownIcons
